import { render, staticRenderFns } from "./profile-change-password-form-by-password.vue?vue&type=template&id=57d7e48c&scoped=true&"
import script from "./profile-change-password-form-by-password.vue?vue&type=script&lang=js&"
export * from "./profile-change-password-form-by-password.vue?vue&type=script&lang=js&"
import style0 from "./profile-change-password-form-by-password.vue?vue&type=style&index=0&id=57d7e48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d7e48c",
  null
  
)

export default component.exports